module.exports = __webpack_public_path__ + "static/media/host-and-event-header.8ffa3440.jpg";